import * as Yup from "yup";
import { UserOperationLog } from "../../../entity/UserOperationLog";

/***************************************************************
 * ユーザー新規追加
 **************************************************************/
/**
 * エラーメッセージ
 */
export const ERR_MESSAGE = {
  idIsNull: "ユーザーIDを入力してください。",
  fullNameIsNull: "氏名を入力してください。",
  emailIsNull: "メールアドレスを入力してください",
  passwordIsNull: "パスワードを入力してください",
  passwordAgainIsNull: "パスワード(確認)を入力してください",
  lockStatusIsNull: "ステータスを選択してください。",
  isMfaauthIsNull: "MFA認証を選択してください。",
  check: "チェックしてください。",
};

/**
 * バリデーションルール
 */
export const ContractUserCreateFormSchema = Yup.object({
  fullName: Yup.string().required(ERR_MESSAGE.fullNameIsNull),
  email: Yup.string().required(ERR_MESSAGE.emailIsNull),
  password: Yup.string().required(ERR_MESSAGE.passwordIsNull),
  passwordAgain: Yup.string().required(ERR_MESSAGE.passwordAgainIsNull),
  lockStatus: Yup.string().required(ERR_MESSAGE.lockStatusIsNull),
  isMfaauth: Yup.string().required(ERR_MESSAGE.isMfaauthIsNull),
});
export const ContractUserEditFormSchema = Yup.object({
  fullName: Yup.string().required(ERR_MESSAGE.fullNameIsNull),
  email: Yup.string().required(ERR_MESSAGE.emailIsNull),
  lockStatus: Yup.string().required(ERR_MESSAGE.lockStatusIsNull),
  isMfaauth: Yup.string().required(ERR_MESSAGE.isMfaauthIsNull),
});
/**
 * ユーザー新規作成・編集フォーム(入力チェック用)
 */
export class ContractUserEditForm {
  /** ユーザーID */
  public userId: string = "";
  /** 氏名 */
  public fullName: string = "";
  /** メールアドレス */
  public email: string = "";
  /** パスワード */
  public password: string = "";
  /** パスワード(確認用) */
  public passwordAgain: string = "";
  /** ロックステータス */
  public lockStatus: string = "";
  /** アカウント有効期限 */
  public expireDate: string = "";
  /** アカウント有効期限（表示用） */
  public expireDateView: Date | null = null;
  /** 作成者 */
  public createUser: string = "";
  /** 作成日時 */
  public createDate: string = "";
  /** 更新者 */
  public updateUser: string = "";
  /** 更新日時 */
  public updateDate: string = "";
  /** 削除日時 */
  public deleteDate: string = "";
  /** MFA認証 */
  public isMfaauth: string = "";
  /** コメント */
  public comment: string = "";
}
// 新規追加用 リクエスト
export class ContractUserCreateRequest {
  createdata: ContractUserEditForm = new ContractUserEditForm();
}
// 編集用 リクエスト
export class ContractUserEditRequest {
  editdata: ContractUserEditForm = new ContractUserEditForm();
}

/***************************************************************
 * ユーザー詳細
 **************************************************************/
/**
 * ユーザー詳細取得API リクエスト
 */
export class ContractUserDetailRequest {
  /** ユーザーID */
  public id: string = "";
}

/**
 * ユーザー詳細取得API レスポンス
 */
export class ContractUserDetailResponse {
  /** ユーザーID */
  public id: string = "";
  /** 氏名 */
  public fullName: string = "";
  /** メールアドレス */
  public email: string = "";
  /** パスワード */
  public password: string = "";
  /** パスワード(確認用) */
  public passwordAgain: string = "";
  /** ロック日時 */
  public lockDate: string = "";
  /** アカウント有効期限 */
  public expireDate: string = "";
  /** 作成者 */
  public createUser: string = "";
  /** 作成日時 */
  public createDate: string = "";
  /** 更新者 */
  public updateUser: string = "";
  /** 更新日時 */
  public updateDate: string = "";
  /** 削除日時 */
  public deleteDate: string = "";
  /** 最終ログイン日時 */
  public lastloginDate: string = "";
  /** MFA認証 */
  public isMfaauth: string = "";
  /** コメント */
  public comment: string = "";
}

/***************************************************************
 * 他箇所との連携用
 **************************************************************/
/**
 * ユーザー情報（ID、氏名）取得API リクエスト
 */
export class ContractUserNameRequest {
  /** テナントID */
  public id: string = "";
}
/**
 * ユーザー情報（ID、氏名）取得API レスポンス
 */
export class ContractUserNameResponse {
  /** テナントID */
  public id: string = "";
  /** 氏名 */
  public userName: string = "";
}